import { useState } from 'react';
import { api, ErrorApi, type CrashResuelto } from '../api';
import { describirEmparejado, estadoDeResolucion, trazaCorta } from '../crash';

/**
 * La traza de un crash, resuelta.
 *
 * Se pide bajo demanda y no con el informe. Resolver un volcado nativo arranca
 * un proceso en el servidor y leer un `mapping.txt` recorre un archivo de
 * cien megabytes: hacerlo para los cinco hallazgos de un informe que alguien
 * abre para mirar el resumen sería trabajo tirado casi siempre.
 *
 * El cuerpo de la traza es el texto que arma el servidor, tal cual. Es el mismo
 * que se pega en un ticket, y rehacer el formateo acá sería mantener las
 * mismas reglas en dos lugares.
 */
export function Crash({ traceId }: { traceId: string }) {
  const [datos, setDatos] = useState<CrashResuelto | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [cargando, setCargando] = useState(false);
  const [abierto, setAbierto] = useState(false);

  async function abrir(): Promise<void> {
    if (datos) {
      setAbierto(!abierto);
      return;
    }
    setCargando(true);
    setError(null);
    try {
      setDatos(await api.crash(traceId));
      setAbierto(true);
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'no se pudo resolver la traza');
    } finally {
      setCargando(false);
    }
  }

  const estado = datos ? estadoDeResolucion(datos) : null;
  const emparejado = datos ? describirEmparejado(datos.emparejado ?? null) : null;

  return (
    <div className="crash">
      <button className="secundario" onClick={() => void abrir()} disabled={cargando}>
        {cargando ? 'Resolviendo…' : abierto ? 'Ocultar traza' : 'Ver traza'}
      </button>
      <code className="tenue">{trazaCorta(traceId)}</code>

      {error && <p className="error">{error}</p>}

      {abierto && datos && estado && (
        <div className="crash-detalle">
          <div className="crash-estado">
            <span className={`chip estado-${estado.nivel}`}>{estado.titulo}</span>
            {emparejado && <span className="chip">Símbolos: {emparejado}</span>}
            <button
              className="secundario"
              onClick={() => void navigator.clipboard?.writeText(datos.texto)}
            >
              Copiar
            </button>
          </div>

          {estado.quePuedoHacer && <p className="crash-accion">{estado.quePuedoHacer}</p>}

          {/* El volcado puede tener treinta marcos: se desplaza dentro de su
              caja en vez de estirar la página. */}
          <pre className="volcado">{datos.texto}</pre>
        </div>
      )}
    </div>
  );
}
